import React from "react";
import Slider from "react-slick";
import "../../Assests/Globalcss/stylesheet.css";
import Footer from "../../Componenets/Footer";
import arrival_bloom1 from "../../Assests/Globalimages/bloom (1).png";
import arrival_bloom2 from "../../Assests/Globalimages/bloom (2).png";

import will_get1 from "../../Assests/customImages/will-get-one.png";
import will_get2 from "../../Assests/customImages/will-get-two.png";

import will_get3 from "../../Assests/customImages/will-get-three.png";

import about_us from "../../Assests/Globalimages/About_image.png";
import bloom3 from "../../Assests/Globalimages/bloom (3).png";
import bloom2 from "../../Assests/Globalimages/bloom (2).png";
import bloom1 from "../../Assests/Globalimages/bloom (1).png";
import unique3 from "../../Assests/Globalimages/unique-icon (3).png";
import unique2 from "../../Assests/Globalimages/unique-icon (2).png";
import unique1 from "../../Assests/Globalimages/unique-icon (1).png";
import unique5 from "../../Assests/Globalimages/unique-icon (5).png";
import nature16 from "../../Assests/Globalimages/nature1 (16).png";
import solid_soap from "../../Assests/Globalimages/fa-solid_soap.png";
import hand_image from "../../Assests/Globalimages/hand-image.png";
import story_img from "../../Assests/Globalimages/our-story-image.png";
import our_mission from "../../Assests/Globalimages/our-mission.png";
import our_vision from "../../Assests/Globalimages/our-vision1.png";
import bloom from "../../Assests/Globalimages/bloom.png";
import click from "../../Assests/Globalimages/click.png";
import Navbar from "../../Componenets/Navbar";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
const index = () => {
  const testimonials = [
    {
      id: 1,
      text: "If you are looking for soap that is not only pretty, unique, and wonderfully scented, then Lynn Martin's My Favorite Things luxurious handmade soaps are for you. I've been using her beautifully crafted creations for years. They add a nice accent to one's bathroom and make lovely gifts to give.",
      author: "Adrienne Birchler"
    },
    {
      id: 2,
      text: "I have used 'My Favorite Things' Chamomile Sugar Scrub and it is so nice. It leaves your skin soft and smooth by gently exfoliating with sugar crystals. No more rough skin.",
      author: "Lisa"
    },
    {
      id: 3,
      text: "My Favorite Things soaps and products are high quality and the scents are amazing. I have been a customer for several years now and have never been disappointed. The soaps are pure and soothing to the skin. I love the pretty decorative designs on the soaps that are enjoyable to look at as they are excellent to use. Recently, I received a beautiful jar of potpourri from Lynn, the owner of My Favorite Things. It has a wonderful fragrance that fills the room with a light aroma of warm scents, which is especially nice and enjoyable as we go through these days of winter.",
      author: "Linda P."
    },
    {
      id: 4,
      text: "Looks Amazing.",
      author: "Happy Customer"
    }
  ];


  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // This should change for mobile
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 768, // Tablets
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // Mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div>
      
      {/* <!-- banner section is started  --> */}
      <section class="About-banner">
        <div class="container">
          <div class="row">
            <div class="About-handmade">
              {/* <span>About Us</span> */}
              {/* <Typography sx={{fontSize: {xs: 16, sm:18, md:30, lg:33},color:'#fff',fontWeight:'bold', width: {md:'auto', lg:910}}}>
                Pure, Handmade, and Nourishing - Experience the Goodness of
                Nature.
              </Typography> */}

              <div class="content-shop-now text-center">
                <h3 style={{color: 'white'}}>About Us</h3>
                <h1 style={{color: 'white'}}>Pure, Handmade, and Nourishing - Experience the Goodness of
                Nature. </h1>
              </div>
              <Link to={'/Shop'}>
              <button className="shop_now_about_us"  >Shop Now</button>

              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- About_section --> */}
      <div class="About_section">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <img class="img-fluid" src={about_us} alt="" />
            </div>
            <div class="col-lg-6 d-flex justify-content-center flex-column">
              <div class="about_text">
                <img src={bloom3} alt="" />
                <h4>ABOUT US</h4>
                <img src={bloom} alt="" />
              </div>
              <div class="enim_text">
                <p>
                Fresh, Pure, and Always Natural.
                Goat's milk is a very mild soap that lathers up well and is one of the very best soaps you can get. I have a small line of men's products as well as many other products that you may be interested in such as potpourri sachets, sugar scrubs, travel soaps and bath salts. I appreciate your interest in my soaps.
                </p>
             
              </div>
              <div>
                <div class="click_image_text mt-4">
                  <img src={click} alt="" />
                  <p>All products are handmade with premium, skin-safe ingredients.
                  </p>
                </div>
                <div class="click_image_text mt-4">
                  <img src={click} alt="" />
                  <p>Goat milk is sourced from local farms to ensure freshness and purity.</p>
                </div>
                <div class="click_image_text mt-4">
                  <img src={click} alt="" />
                  <p>Includes specialty lines for men’s grooming and daily skincare.</p>
                </div>
                <div class="click_image_text mt-4">
                  <img src={click} alt="" />
                  <p>Custom gift sets and seasonal collections available upon request.</p>
                </div>
              </div>
              <div class="about-payy-now">
              <Link to={'/Shop'}>
                <button className="about_us_Page_btns"  >Shop Now</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- What Makes Us Unique --> */}
      <section class="unique-section">
        <div class="container">
          <div class="row">
            <div class="about_text about_text1  d-flex justify-content-center text-center align-items-center">
              <img src={bloom2} alt="" />
              <h4>What Makes Us Unique?</h4>
              <img src={bloom1} alt="" />
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 mt-5">
              <div class="natural-text">
                <img src={unique3} alt="" />
                <h4>100% Natural & Handmade</h4>
                <p> Purely crafted with nature’s best, no synthetics used.
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 mt-5">
              <div class="natural-text">
                <img src={hand_image} alt="" />
                <h4>Ethically Sourced </h4>
                <p>Ingredients gathered with care, supporting fair practices.
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 mt-5">
              <div class="natural-text">
                <img src={unique2} alt="" />
                <h4> Eco-Friendly Packaging</h4>
                <p>Sustainable wrapping that’s kind to the planet we love.
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 mt-5">
              <div class="natural-text">
                <img src={unique1} alt="" />
                <h4>Inspired by Nature</h4>
                <p>Floral and herbal essences bring the outdoors to you.</p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 mt-5">
              <div class="natural-text">
                <img src={unique5} alt="" />
                <h4>Small Batches, Big Love</h4>
                <p>Each soap is made with care in small, heartfelt batches.</p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 mt-5">
              <div class="natural-text">
                <img src={solid_soap} alt="" />
                <h4> Eco-Friendly Packaging</h4>
                <p>Our soaps are never tested on animals, only on humans.</p>
              </div>
            </div>
            <div class="learn_btn">
            <Link to={'/ContactUs'}>
              <button className="about_us_Page_btns" >Learn more</button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- our_story --> */}
      <section class="Our_story">
        <div class="container">
          <div class="row">
            <div class="col-lg-7 d-flex justify-content-center flex-column">
              <div>
                <div class="about_text">
                  <img src={bloom3} alt="" />
                  <h4>OUR STORY</h4>
                  <img src={bloom} alt="" />
                </div>
                <div class="started_text">
                  <h4>
                  Born from a love for natural beauty, MY FAVORITE THINGS blends organic ingredients into luxurious, chemical-free soaps for glowing, healthy skin.
                  </h4>
                  <p>
                  It all began in a small kitchen, where we experimented with goat's milk, lavender, and floral essences to create soaps that nourish and delight. From our Small Rose Goats Milk Soap to the Ornate Heart with Flowers, each bar reflects our commitment to sustainability, beauty, and the joy of self-care.
                  </p>
                  <p>
                  Today, we’re proud to offer a range of handcrafted soaps, bath salts, and scrubs that bring nature’s best to your daily routine, crafted with love and eco-conscious care!{" "}
                  </p>
                  <Link to={'/Shop'}>
                  <button className="about_us_Page_btns" style={{marginBottom:10}}  >Shop Now</button>      

                  </Link>
                            </div>
              </div>
            </div>
            <div class="col-lg-5">
              <div>
                <img class="img-fluid" src={story_img} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
 

      {/* <!-- Swiper -->  */}
      <section class="slider-section"  style={{background:'#F5A3B730', }}>
        <div class="sliderMainDiv">
        <div class="container">
          <div class="heading-swiper d-flex justify-content-center">
            <h1 className="mb-4">
              What our <span class="customer">customer</span> says
            </h1>
          </div>
          <div class="swiper mySwiper">
            <div class="swiper-wrapper" >
            <Slider {...settings}>
            {testimonials?.map((item, index) => (
              <div key={item.id || index} className="slider-content">
                <div className="star-slider d-flex">
                  <img src={nature16} className="img-fluid starts" alt="star" />
                  <img src={nature16} className="img-fluid starts" alt="star" />
                  <img src={nature16} className="img-fluid starts" alt="star" />
                  <img src={nature16} className="img-fluid starts" alt="star" />
                </div>
                <div className="para-slider">
                  <p style={{fontSize: 12.5, fontWeight: 500, padding: "0px 25px"}}>
                    "{item.text}"
                  </p>
                </div>
                <h6 style={{fontSize: 16, textAlign: 'center'}}>
                  — {item.author}
                </h6>
              </div>
            ))}
        </Slider>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        </div>
       
      </section>

      <section class="free_shepping_section" style={{background:'white',marginTop:115}}>
        <div class="container">
          <div class="row d-flex justify-content-center"  >
            {/* <div class="shope_now" style={{}}>
              <img src={arrival_bloom2} alt="" />
              <h4 style={{textTransform:'capitalize'}}>you will get</h4>
              <img src={arrival_bloom1} alt="" />
            </div> */}
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="season_text">
              <img src={will_get1} alt="" />
                              <h4 style={{fontSize:20, fontWeight:600}}>Season Sale</h4>
                <p >
                Pamper your skin for less! Enjoy special seasonal discounts on our handcrafted goat milk soaps. Treat yourself or someone you love to nourishing skincare at unbeatable prices. Shop now your skin will thank you!
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="season_text">
              <img src={will_get2} alt="" />
                <h4 style={{fontSize:20, fontWeight:600}}> Shipping</h4>
                <p >
                We know you can’t wait to experience the goodness of our goat milk soap. That’s why we offer quick and secure shipping straight to your door with tracking available on every order.
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="season_text">
              <img src={will_get3} alt="" />

                <h4 style={{fontSize:20, fontWeight:600}}>Money Back Gurantee</h4>
                <p >
                We care about happy skin and happy customers! If you're not completely satisfied with our soap, we offer a full money-back guarantee. Shop with confidence your satisfaction is our promise.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default index;
